module.exports = __webpack_public_path__ + "static/media/previous.5cb0de7f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Paper/previous.svg
// module id = 723
// module chunks = 3